import { Icon, Question } from "@phosphor-icons/react";
import Title from "./Title";
import { motion } from "motion/react";
import { getTitleColor } from "@/lib/titleColors";

function SideTitle({
  intro,
  title,
  icon: TitleIcon,
  showHelpIndicator,
  onHelpClick,
}: {
  title: string;
  intro: string;
  icon?: Icon;
  showHelpIndicator?: boolean;
  onHelpClick?: () => void;
}) {
  const iconColor = getTitleColor(title);

  return (
    <motion.hgroup layout id="side-title" className="mt-[24px] @md:pr-9  pr-3">
      <span className="flex flex-row items-center">
        <Title title={title}>{title}</Title>
        {TitleIcon && (
          <button
            type="button"
            onClick={showHelpIndicator ? onHelpClick : undefined}
            className={`ml-auto relative group ${showHelpIndicator ? "cursor-pointer" : "cursor-default"}`}
            aria-label={showHelpIndicator ? "Open quick guide" : undefined}
            tabIndex={showHelpIndicator ? 0 : -1}
          >
            <TitleIcon
              size={29}
              color={iconColor}
              className={showHelpIndicator ? "transition-opacity group-hover:opacity-25" : ""}
            />
            {showHelpIndicator && (
              <Question
                size={20}
                weight="bold"
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity"
              />
            )}
          </button>
        )}
      </span>
      <p className={"text-main-subtitle"}>{intro}</p>
    </motion.hgroup>
  );
}

export default SideTitle;
